import AdminPushHttpService from 'dataStore/service/adminPush.service'
import { registerAdminServiceWorker } from 'handlers/registerAdminServiceWorker'
import { urlBase64ToUint8Array } from 'handlers/urlBase64ToUint8Array'

/**
 * Подписывает текущее устройство на Web Push и сохраняет subscription на сервере.
 * @param preferredPizzeriaId — фильтр как на главной; null = все в scope
 */
export const subscribeAdminPush = async (
  preferredPizzeriaId: number | null
): Promise<void> => {
  if (!('PushManager' in window) || !('serviceWorker' in navigator)) {
    throw new Error('Web Push не поддерживается в этом браузере')
  }

  const registration = await registerAdminServiceWorker()

  await navigator.serviceWorker.ready

  // На iOS иногда ready есть, но pushManager ещё не готов сразу после первой регистрации
  if (!registration?.pushManager) {
    throw new Error(
      'PushManager недоступен. Откройте админку с ярлыка «Домой» (PWA), iOS 16.4+.'
    )
  }

  const { data } = await AdminPushHttpService.getVapidPublicKey()
  const publicKey = data?.publicKey
  if (!publicKey) {
    throw new Error('Сервер не отдал VAPID public key')
  }

  let subscription = await registration.pushManager.getSubscription()
  if (!subscription) {
    subscription = await registration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(publicKey),
    })
  }

  const json = subscription.toJSON()
  const endpoint = json.endpoint
  const p256dh = json.keys?.p256dh
  const auth = json.keys?.auth
  if (!endpoint || !p256dh || !auth) {
    throw new Error('Некорректная PushSubscription')
  }

  await AdminPushHttpService.upsertSubscription({
    endpoint,
    p256dh,
    auth,
    preferredPizzeriaId,
    userAgent: typeof navigator !== 'undefined' ? navigator.userAgent : null,
  })
}
